const background = {
  main: "#eee",
  light: "#fafafa",
  dark: "#D6DAE0",
};
export { background };
